'use strict';

angular.module('libraryModule')
.controller('EditLibraryFolderCtrl', EditLibraryFolderCtrl);


function EditLibraryFolderCtrl ($scope, model, Uploader, File)
{
    $scope.model = model;
    $scope.modelNameField = 'name';
    $scope.tagging = false;

    $scope.uploader = new Uploader({autoUpload: true});
    $scope.uploader.onSuccessItem = onSuccessItem;
    $scope.remove = remove;

    File.bindAll({asset_id: $scope.model.id}, $scope, 'files');

    $scope.$watch('model.id', function ()
    {
        $scope.uploader.formData = [{asset_id: $scope.model.id}];
    });

    this.saveFolder = function ()
    {
        $scope.model.DSCreate({upsert: true}).then($scope.$close);
    };

    function remove (fileItem)
    {
        // for editing asset, existing files, already bind File to this item
        if (fileItem.DSDestroy) {
            fileItem.DSDestroy();
        } else {
            fileItem.remove();
        }
    }

    function onSuccessItem (fileItem, response)
    {
        // remove from uploader.queue
        fileItem.remove();

        var params = {asset_id: model.id};
        File.ejectAll(params);
        $scope.file = [File.inject(response)];
    }
};